import { useQuery } from "react-query";
import { getHierarchies } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetHierarchies = () => {
  return useQuery("GetHierarchies", getHierarchies, {
    refetchOnWindowFocus: false,
  });
};
